import { gql } from '@apollo/client'

export default gql`
  fragment EmployeeCore on Employee {
    id
    legalFirstName
    legalLastName
    chosenFirstName
    chosenLastName
  }
`
